// Initial variant selection of a product: first available combination, else the main-price one, else the first.

export const get_default_mix_variant = (data) => {
  const available_mix_variant = data?.mix_variant?.find(
    (variant) => variant?.price?.price > 0 && variant?.details?.count > 0,
  );
  const main_mix_variant = data?.mix_variant?.find(
    (variant) => variant?.is_main_price,
  );
  const first_mix_variant = data?.mix_variant?.[0];
  return available_mix_variant
    ? available_mix_variant
    : main_mix_variant
      ? main_mix_variant
      : first_mix_variant;
};

// `{ [variant_id]: "<variant_id>-<label_id>" }` for the labels named in `labels_query` ("key,key", the
// `?selected-labels=` link parameter) or, without one, for the default combination.
export const get_initial_selected_labels = ({ data, labels_query, exception_variant_key } = {}) => {
  let obj = {};
  if (labels_query?.length > 0) {
    labels_query?.split(",")?.forEach((label_key) => {
      data?.variants?.forEach((variant) => {
        const label_id = variant?.labels?.find(
          (label) => label?.key === label_key,
        )?.id;

        if (label_id) {
          const variant_id = variant?.variant?.id;
          obj[variant_id] = `${variant_id}-${label_id}`;
        }
      });
    });
  } else {
    get_default_mix_variant(data)?.keys?.forEach((key) => (obj[key?.split("-")?.[0]] = key));
  }
  if (exception_variant_key) {
    const variant = data?.variants?.find(
      (variant) => variant?.variant?.key === exception_variant_key,
    );
    if (variant) {
      obj = {
        ...obj,
        [variant?.variant?.id]:
          `${variant?.variant?.id}-${variant?.variant?.labels?.[0]?.id}`,
      };
    }
  }

  return obj;
};
